import { useCallback } from 'react';
import { createSearchParams, useSearchParams } from 'react-router';

import { useDeferredNavigate } from 'hooks/useDeferredNavigate';
import { useLatest } from 'hooks/useLatest';
import { useSearchAnalytics } from 'modules/search/hooks/useSearchAnalytics';
import { trackEvent } from 'utils/analytics/track/trackEvent';

export function useSearchFacetToggleOption(filterType: string) {
  const [searchParams] = useSearchParams();
  const searchParamsRef = useLatest<URLSearchParams>(searchParams);

  const navigate = useDeferredNavigate();

  const { getSearchTrackingData } = useSearchAnalytics();

  const toggle = useCallback(
    (name: string) => {
      const filterSelected = searchParamsRef.current.has(filterType, name);

      if (filterSelected) {
        searchParamsRef.current.delete(filterType, name);
        (
          document.querySelector(
            `[data-facet-type=${filterType}] input[name=${name}]`,
          ) as HTMLInputElement
        ).checked = false;
      } else {
        searchParamsRef.current.append(filterType, name);
        (
          document.querySelector(
            `[data-facet-type=${filterType}] input[name=${name}]`,
          ) as HTMLInputElement
        ).checked = true;
      }

      trackEvent('Changed Search Filter', {
        filter_name: `${filterType}Facet`,
        [filterSelected ? 'selected_value' : 'deselected_value']: name,
        ...getSearchTrackingData(),
      });

      const newSearchParams = createSearchParams(searchParamsRef.current);

      navigate(`?${newSearchParams}`, { replace: true });
    },
    [filterType, getSearchTrackingData, navigate, searchParamsRef],
  );

  return toggle;
}
